import { useMutation } from '@tanstack/react-query';
import { inviteUser as inviteUserService } from 'services/api/AccessManagerAPI';

export const useInviteUser = () => {
    const { mutateAsync: inviteUser, isPending } = useMutation({
        mutationFn: inviteUserService,
        retry: false,
    });

    return { inviteUser, isPending };
};
